<template>
   <div class="">
    <button class="btn dealers_btn mr-3" @click="openFundWalletModal" style="font-size: 15px" v-if="data.approved">
       {{ $t('text.clickButtons.fundAccount') }} 
    </button>
    <button class="btn dealers_btn mr-3" @click="deleteSubAccount" style="font-size: 15px" >
       {{ $t('text.actionButtons.delete') }}
    </button>
    <i class="fa-li fa fa-ellipsis-v dropbtn" @click="dropdownOption()" v-if="data.approved"></i>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
      window.onclick = (event) => {
            if (!event.target.matches('.dropbtn')) {
                  var dropdowns = document.getElementsByClassName("dropdown-content");
                  var i;
                  for (i = 0; i < dropdowns.length; i++) {
                        var openDropdown = dropdowns[i];
                        if (openDropdown.classList.contains('show')) {
                        openDropdown.classList.remove('show');
                        }
                  }
            }
      }
      
  },
  methods: {
      openFundWalletModal() {
        this.$eventHub.$emit('_fundAccount', (this.data));
      },
      dropdownOption() {
        this.$eventHub.$emit('showExtraCompanyButtons', this.data)
      },
      deleteSubAccount () {
          var deleteConfirm = confirm(this.$t('text.subAccounts.confirmDelete'));
          if(deleteConfirm){
              let data = {
                  "id": this.data.userId
              }
              this.axios.post(`${configObject.apiBaseUrl}/SubAccount/Remove`, data, configObject.authConfig())
                  .then(() => {                
                      this.$toast.open({
                          message: this.$t('text.subAccounts.successfullyDeleted'),
                          type: 'success',
                          duration: 5000
                      });
                      this.$eventHub.$emit('refreshSubAccountsList')
                  }).catch(error => {       
                      this.$toast.open({
                          message: error.response.data.message ,
                          type: 'error',
                          duration: 5000
              });
                });
          }
      },
  },
};

</script>